<template>
  <card class="pt-3 pb-3">
    <list
      :columns="columns"
      :modalCreate="modalCreate"
      :removeLink="removeLink"
      :cardLink="cardLink"
      :isUpdate="true"
      :isAdd="true"
      :fields="fields"
      :itemLink="itemLink"
      :setLink="setLink"
      :searchDisable="true"
      @change="change"
      @changeFunction="changeFunction"
    />
  </card>
</template>
<script>
import List from "../components/List";

import { mapState, mapMutations } from "vuex";

export default {
  name: "groups",
  components: {
    List,
  },
  methods: {
    changeFunction(val) {},
    change(val) {
      this.value = Array.isArray(val) ? val : [val];
    },
  },
  data() {
    return {
      /**START ADD ITEM */
      modalCreate: "groups",
      fields: [
        {
          label: "Название",
          key: "name",
          type: "text",
        },
        {
          label: "Максимальная цена просмотра",
          key: "max_price",
          type: "numeric",
        },
        {
          label: "Скидка (%) на товары",
          key: "sale",
          type: "numeric",
        },
      ],
      /** APIs */
      removeLink: "admin/groups/delete",
      cardLink: "group",
      itemLink: "admin/groups",
      setLink: "admin/groups/create",
      /** COLUMNS MODEL */
      columns: [
        {
          key: "id",
          title: "ID группы",
          checkbox: false,
          control: false,
          align: "left",
        },
        {
          key: "name",
          title: "Наименование",
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: true,
        },
        {
          key: "sale",
          title: "Скидка (%)",
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
        },
        {
          key: "max_price",
          title: "Максимальная цена просмотра",
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
        },
        {
          key: "",
          title: "",
          checkbox: false,
          remove: true,
          align: "right",
        },
      ],
      value: null,
    };
  },
};
</script>
<style>
</style>
